import * as i18next from 'i18next';
import * as i18nextXHRBackend from 'i18next-xhr-backend';

export const i18nInstance = i18next.createInstance();

export default function i18n({ locale, baseUrl = '' }) {
  return i18nInstance.use(i18nextXHRBackend).init({
    lng: locale,
    fallbackLng: 'en',
    keySeparator: '$',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `${baseUrl}assets/locale/account-teams-client/messages_{{lng}}.json`,
      crossDomain: true
    },
    react: {
      wait: true
    }
  });
}
